import React, { useState } from "react";

const KitchenEstimate = ({ onReset }) => {
  const [kitchenSize, setKitchenSize] = useState(""); // To track kitchen size input
  const [kitchenStyle, setKitchenStyle] = useState("Traditional"); // To track selected kitchen style
  const [estimateRange, setEstimateRange] = useState(null); // To store the calculated estimate range

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload

    // Pricing logic based on selected kitchen style
    let minRatePerSqFt = 0;
    let maxRatePerSqFt = 0;

    switch (kitchenStyle) {
      case "Traditional":
        minRatePerSqFt = 1200;
        maxRatePerSqFt = 1400;
        break;
      case "Modular":
        minRatePerSqFt = 2000;
        maxRatePerSqFt = 2500;
        break;
      case "Contemporary":
        minRatePerSqFt = 3000;
        maxRatePerSqFt = 5000;
        break;
      default:
        minRatePerSqFt = 2000;
        maxRatePerSqFt = 2000;
    }

    // Calculate total estimate range
    const minEstimate = kitchenSize * minRatePerSqFt;
    const maxEstimate = kitchenSize * maxRatePerSqFt;

    setEstimateRange({ minEstimate, maxEstimate }); // Update the estimate range state
    console.log(`Kitchen Estimate Range: ₹${minEstimate} - ₹${maxEstimate}`); // Log the estimate range
  };

  const handleReset = () => {
    setKitchenSize(""); // Reset kitchen size
    setKitchenStyle("Traditional"); // Reset kitchen style to default
    setEstimateRange(null); // Clear the estimate range
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-semibold text-center mb-4">
        Kitchen Cost Estimator
      </h2>
      <form className="space-y-4" onSubmit={handleSubmit}>
        {/* Kitchen Size Input */}
        <div>
          <label
            htmlFor="kitchenSize"
            className="block text-sm font-medium text-gray-700"
          >
            Kitchen Size (in sq. ft.)
          </label>
          <input
            type="number"
            id="kitchenSize"
            value={kitchenSize}
            onChange={(e) => setKitchenSize(e.target.value)} // Update kitchen size
            className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            placeholder="Enter size"
            required
          />
        </div>

        {/* Kitchen Style Selection */}
        <div>
          <label
            htmlFor="kitchenStyle"
            className="block text-sm font-medium text-gray-700"
          >
            Choose Kitchen Style
          </label>
          <select
            id="kitchenStyle"
            value={kitchenStyle} // Controlled component, should always reflect the state value
            onChange={(e) => setKitchenStyle(e.target.value)} // Update kitchen style
            className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
          >
            <option value="Traditional">Traditional</option>
            <option value="Modular">Modular</option>
            <option value="Contemporary">Contemporary</option>
          </select>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full py-3 bg-yellow-500 text-white rounded hover:bg-yellow-400 focus:outline-none"
        >
          Calculate Estimate
        </button>
      </form>

      {/* Show the calculated estimate range */}
      {estimateRange !== null && (
        <div className="mt-4 text-center">
          <p className="text-lg">
            Total Kitchen Estimate: <br />₹
            {estimateRange.minEstimate.toLocaleString()} - ₹
            {estimateRange.maxEstimate.toLocaleString()}
          </p>
        </div>
      )}

      {/* Reset Button */}
      <button
        onClick={handleReset}
        className="mt-4 w-full py-3 bg-gray-400 text-white rounded hover:bg-gray-600 focus:outline-none"
      >
        Reset
      </button>
    </div>
  );
};

export default KitchenEstimate;
